import React from "react";
import { Table, Tag, Button, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

export default function TabelaPedidosFormando(props) {
  const { data, handleClickPedido, formatarMoedaBr, confirmarProducao } = props;

  const columns = [
    {
      title: "ID",
      dataIndex: "pedido",
      key: "pedido",
      render: (text) => <b>#{text}</b>,
    },
    {
      title: "Forma de Pagamento",
      dataIndex: ["cobranca", "formaPagamento"],
      key: "formaPagamento",
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        // Verifica se o pedido foi cancelado
        if (record.status === "Pedido cancelado") {
          return <Tag color="red">CANCELADO</Tag>;
        }

        // Verifica se o pedido está em processo de cancelamento
        if (record.status === "Pedido em cancelamento") {
          return <Tag color="orange">CANCELAMENTO SOLICITADO</Tag>;
        }

        // Verifica se o valor pago é igual ao valor total (pedido pago)
        if (record.cobranca.valorJaPago >= record.cobranca.valor) {
          return <Tag color="green">PAGO</Tag>;
        }

        // Se não está pago completamente, está pendente
        return <Tag color="gold">PENDENTE</Tag>;
      },
    },
    {
      title: "Valor Total",
      dataIndex: ["cobranca", "valor"],
      key: "valor",
      render: (val) => formatarMoedaBr(val),
    },
    {
      title: "Valor Pago",
      dataIndex: ["cobranca", "valorJaPago"],
      key: "valorJaPago",
      render: (val) => formatarMoedaBr(val),
    },
    {
      title: "Ações",
      key: "acoes",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <Tooltip title="Ver detalhes do pedido">
            <Button
              type="primary"
              shape="circle"
              icon={<EyeOutlined />}
              onClick={handleClickPedido(record)}
            />
          </Tooltip>
          {confirmarProducao && (
            <Button onClick={() => confirmarProducao(record.pedido)}>
              Confirmar produção
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      className="custom-table-header"
      dataSource={data}
      columns={columns}
      rowKey="pedido"
      pagination={{ pageSize: 5 }}
      locale={{ emptyText: "Este formando não realizou nenhuma compra" }}
      scroll={{ x: true }}
    />
  );
}                